import React, { Component } from "react";
import {
  Statistic,
  Grid,
  Message,
  Button,
  Table,
  Header,
  Label,
} from "semantic-ui-react";
import { getGeneralReport, getOverAllReport } from "../services/reportService";
import Chart from "chart.js";
import BlockUi from "react-block-ui";
import TableTitle from "./common/tableTitle";
import auth from "../services/authService";
import Currency from "./common/currency";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { Link } from "react-router-dom";

class Dashboard extends Component {
  state = {
    report: { newRooms: [], newVehicles: [], newVisas: [], newYards: [] }, //outlet_account: [], companyExpiryCounter: []
    totalUsers: 0,
    dashboard: "client",
    outletid: "",
    overall: {},
    startDate: "",
    endDate: "",
    inReportLink: "/report/passport-inout?flag=1",
    outReportLink: "/report/passport-inout?flag=2",
    invoiceReportLink: "/report/invoices",
    checkPaidReportLink: "/report/cheques/pdc-paid?flag=0",
    checkReceivedReportLink: "/report/cheques/pdc-received?flag=1",
    vehicleExpiryReportLink: "/report/expiry/vehicle",
    visaExpiryReportLink: "/report/expiry/visa",
    passportExpiryReportLink: "/report/expiry/passport",
    runningProjectsReportLink: "/report/projects?flag=1",
    stopedProjectsReportLink: "/report/projects?flag=3", // stopped in backend its value is 0
    completedProjectsReportLink: "/report/projects?flag=2",
    documentsExpiryReportLink: "/report/documents-expiry",
  };

  handleChangeStartDate = (date) => {
    this.setState({
      startDate: date,
    });
  };

  handleChangeEndDate = (date) => {
    this.setState({
      endDate: date,
    });
  };

  doSubmit = async () => {
    var event = new Date(this.state.startDate);
    event.setDate(event.getDate() + 1);
    let startDate = JSON.stringify(event);
    startDate = startDate.slice(1, 11);

    event = new Date(this.state.endDate);
    event.setDate(event.getDate() + 1);
    let endDate = JSON.stringify(event);
    endDate = endDate.slice(1, 11);

    this.setState({ blocking: true });

    const verifyData = {
      startDate: startDate,
      endDate: endDate,
    };

    const inReportLink =
      "/report/passport-inout?flag=1&start=" + startDate + "&end=" + endDate;
    const outReportLink =
      "/report/passport-inout?flag=2&start=" + startDate + "&end=" + endDate;

    const documentsExpiryReportLink =
      "/report/documents-expiry?start=" + startDate + "&end=" + endDate;

    const invoiceReportLink =
      "/report/invoices?start=" + startDate + "&end=" + endDate;
    const checkPaidReportLink =
      "/report/cheques/pdc-paid?flag=0&start=" + startDate + "&end=" + endDate;
    const checkReceivedReportLink =
      "report/cheques/pdc-received?flag=1&start=" +
      startDate +
      "&end=" +
      endDate;

    const vehicleExpiryReportLink =
      "/report/expiry/vehicle?start=" + startDate + "&end=" + endDate;
    const visaExpiryReportLink =
      "/report/expiry/visa?start=" + startDate + "&end=" + endDate;
    const passportExpiryReportLink =
      "/report/expiry/passport?start=" + startDate + "&end=" + endDate;

    const runningProjectsReportLink = "/report/projects?flag=1";
    const stopedProjectsReportLink = "/report/projects?flag=3"; // stopped in backend its value is 0
    const completedProjectsReportLink = "/report/projects?flag=2";

    const { data: report } = await getOverAllReport(verifyData);
    this.setState({
      report,
      blocking: false,
      documentsExpiryReportLink,
      inReportLink,
      outReportLink,
      invoiceReportLink,
      checkPaidReportLink,
      checkReceivedReportLink,
      vehicleExpiryReportLink,
      visaExpiryReportLink,
      passportExpiryReportLink,
      runningProjectsReportLink,
      stopedProjectsReportLink,
      completedProjectsReportLink,
    });
  };

  doReset = () => {
    this.setState({ startDate: "", endDate: "" });
    //this.reportInitialLoading();
  };

  async componentDidMount() {
    document.body.style.backgroundImage = "none";
    if (auth.getCurrentUser().role === "company") {
      this.setState({ dashboard: "company" });
      this.loadDashboard(auth.getCurrentUser().company_id);
    } else if (auth.getCurrentUser().role === "client") {
      this.setState({
        blocking: true,
      });

      //2021-06-01
      //2021-06-08

      var date = new Date();
      var startDate = new Date(date.getFullYear(), date.getMonth(), 1);
      startDate.setDate(startDate.getDate() + 1);
      let sDate = JSON.stringify(startDate);
      sDate = sDate.slice(1, 11);

      var endDate = new Date(date.getFullYear(), date.getMonth() + 1, 1);
      endDate.setDate(endDate.getDate());
      let eDate = JSON.stringify(endDate);
      eDate = eDate.slice(1, 11);

      const inReportLink = "/report/passport-inout?flag=1";
      const outReportLink = "/report/passport-inout?flag=2";
      const invoiceReportLink =
        "/report/invoices?start=" + sDate + "&end=" + eDate;
      const checkPaidReportLink =
        "/report/cheques/pdc-paid?flag=0&start=" + sDate + "&end=" + eDate;
      const checkReceivedReportLink =
        "report/cheques/pdc-received?flag=1&start=" + sDate + "&end=" + eDate;

      const vehicleExpiryReportLink =
        "/report/expiry/vehicle?start=" + sDate + "&end=" + eDate;
      const visaExpiryReportLink =
        "/report/expiry/visa?start=" + sDate + "&end=" + eDate;
      const passportExpiryReportLink =
        "/report/expiry/passport?start=" + sDate + "&end=" + eDate;

      const runningProjectsReportLink = "/report/projects?flag=1";
      const stopedProjectsReportLink = "/report/projects?flag=3"; // stopped in backend its value is 0
      const completedProjectsReportLink = "/report/projects?flag=2";

      const documentsExpiryReportLink =
        "/report/documents-expiry?start=" + sDate + "&end=" + eDate;

      this.setState({
        documentsExpiryReportLink,
        inReportLink,
        outReportLink,
        invoiceReportLink,
        checkPaidReportLink,
        checkReceivedReportLink,
        vehicleExpiryReportLink,
        visaExpiryReportLink,
        passportExpiryReportLink,
        runningProjectsReportLink,
        stopedProjectsReportLink,
        completedProjectsReportLink,
      });

      const verifyData = {
        startDate: "",
        endDate: "",
      };

      const { data: report } = await getOverAllReport(verifyData);
      this.setState({ report, blocking: false });
    }
  }

  loadDashboard = async (companyId) => {
    this.setState({
      blocking: true,
      show: "none",
      dashboard: "company",
      companyId: companyId,
    });
    const { data: report } = await getGeneralReport(companyId);
    this.setState({ report, blocking: false });
    this.totalUsers();
  };

  barChart(labels, data, colors, container, title) {
    var ctx = document.getElementById(container);
    new Chart(ctx, {
      type: "bar",
      data: {
        labels: labels,
        datasets: [
          {
            label: title,
            data: data,
            backgroundColor: colors,
            borderColor: colors,
            borderWidth: 1,
          },
        ],
      },
      options: {
        scales: {
          yAxes: [
            {
              ticks: {
                beginAtZero: true,
              },
            },
          ],
        },
      },
    });
  }

  totalUsers = () => {
    let total = 0;

    // this.state.report.company_account.map(account =>
    //    total = total + 1;
    // );
    this.setState({ totalUsers: 3 });
  };

  loadCustomerDashboard = () => {
    this.setState({ dashboard: "customer" });
  };

  render() {
    const dashboardIcon =
      process.env.REACT_APP_URL + "/new_theme/dashboard.png";

    let {
      report,
      totalUsers,
      dashboard,
      outletid,
      documentsExpiryReportLink,
      inReportLink,
      outReportLink,
      invoiceReportLink,
      checkPaidReportLink,
      checkReceivedReportLink,
      vehicleExpiryReportLink,
      visaExpiryReportLink,
      passportExpiryReportLink,
      runningProjectsReportLink,
      stopedProjectsReportLink,
      completedProjectsReportLink,
    } = this.state;

    return (
      <BlockUi tag="div" blocking={this.state.blocking}>
        <h1 className="container__heading">Dashboard</h1>
        <p>
          Welcome to your personalized portal, the place where all the magic
          happens. Your dashboard is the hub of your application, where you'll
          find all the tools and information you need to stay ahead of the game.
          Here, you'll have access to all your important data, insights, and
          reports, neatly organized and presented in an easy-to-understand
          format. You can quickly monitor your performance, track your progress,
          and make informed decisions that will help you achieve your goals. Our
          dashboard is designed with you in mind, making it simple to navigate
          and understand, so you can focus on what really matters - growing your
          business. So, sit back, relax, and let our dashboard be your guide.
          We're confident it will be your go-to place for success.
        </p>

        {dashboard !== "company" &&
        auth.getCurrentUser().role !== "salary-admin" ? (
          <article className="grid filters dashboard-filters">
            <DatePicker
              className="input"
              placeholderText="Select Start Date"
              selected={this.state.startDate}
              onChange={this.handleChangeStartDate}
            />
            <DatePicker
              className="input"
              placeholderText="Select End Date"
              selected={this.state.endDate}
              onChange={this.handleChangeEndDate}
            />
            <button className="btn btn--primary" onClick={this.doSubmit}>
              Submit
            </button>
            <button className="btn btn--secondary" onClick={this.doReset}>
              Reset
            </button>
          </article>
        ) : (
          ""
        )}

        <div className="grid grid--1x4 dashboard-stats">
          {dashboard === "company" ? (
            <React.Fragment>
              <div className="card stats">
                <div className="stats__content">
                  <h2 className="card__heading stats__heading">
                    <Link to="/rooms-accounts">Rooms</Link>
                  </h2>
                  <span className="badge badge--primary stats__count">
                    {report.room_count}
                  </span>
                  <p>Total room accounts in the system.</p>
                </div>
                <div className="stats__icon"></div>
              </div>
              <div className="card stats">
                <div className="stats__content">
                  <h2 className="card__heading stats__heading">
                    <Link to="/vehicles-accounts">Vehicles</Link>
                  </h2>
                  <span className="badge badge--primary stats__count">
                    {report.vehicle_count}
                  </span>
                  <p>Total vehicle accounts in the system.</p>
                </div>
                <div className="stats__icon"></div>
              </div>
              <div className="card stats">
                <div className="stats__content">
                  <h2 className="card__heading stats__heading">
                    <Link to="/visas-accounts">Visas</Link>
                  </h2>
                  <span className="badge badge--primary stats__count">
                    {report.visa_count}
                  </span>
                  <p>Total visa accounts in the system.</p>
                </div>
                <div className="stats__icon"></div>
              </div>
              <div className="card stats">
                <div className="stats__content">
                  <h2 className="card__heading stats__heading">
                    <Link to="/yards-accounts">Yards</Link>
                  </h2>
                  <span className="badge badge--primary stats__count">
                    {report.yard_count}
                  </span>
                  <p>Total yard accounts in the system.</p>
                </div>
                <div className="stats__icon"></div>
              </div>
              <div className="card stats">
                <div className="stats__content">
                  <h2 className="card__heading stats__heading">
                    <Link to="/banks-accounts">Bank Accounts</Link>
                  </h2>
                  <span className="badge badge--primary stats__count">
                    {report.company_bank_detail_count}
                  </span>
                  <p>Total bank accounts in the system.</p>
                </div>
                <div className="stats__icon"></div>
              </div>
              <div className="card stats">
                <div className="stats__content">
                  <h2 className="card__heading stats__heading">
                    <Link to="/company-documents">Documents</Link>
                  </h2>
                  <span className="badge badge--primary stats__count">
                    {report.company_document_count}
                  </span>
                  <p>Total documents in the system.</p>
                </div>
                <div className="stats__icon"></div>
              </div>
            </React.Fragment>
          ) : (
            ""
          )}
          {dashboard != "company" &&
          auth.getCurrentUser().role !== "salary-admin" ? (
            <React.Fragment>
              {report.companyExpiryCounter !== undefined ? (
                <div className="card stats">
                  <div className="stats__content">
                    <h2 className="card__heading stats__heading">
                      <Link to={documentsExpiryReportLink}>
                        Documents Expiry
                      </Link>
                    </h2>
                    <span className="badge badge--primary stats__count">
                      {report.companyExpiryCounter}
                    </span>
                    <p>Total documents expired in the system.</p>
                  </div>
                  <div className="stats__icon"></div>
                </div>
              ) : (
                ""
              )}
              <div className="card stats">
                <div className="stats__content">
                  <h2 className="card__heading stats__heading">
                    <Link to="/report/generate-receiveable-report">
                      Receiveable
                    </Link>
                  </h2>
                  <span className="badge badge--primary stats__count">
                    {report.totalReceivable}
                  </span>
                  <p>Total receiveable in the system.</p>
                </div>
                <div className="stats__icon"></div>
              </div>
              <div className="card stats">
                <div className="stats__content">
                  <h2 className="card__heading stats__heading">
                    <Link to="/report/generate-payable-report">Payable</Link>
                  </h2>
                  <span className="badge badge--primary stats__count">
                    {report.totalPayable}
                  </span>
                  <p>Total payable in the system.</p>
                </div>
                <div className="stats__icon"></div>
              </div>
              <div className="card stats">
                <div className="stats__content">
                  <h2 className="card__heading stats__heading">Received</h2>
                  <span className="badge badge--primary stats__count">
                    {report.totalIncome}
                  </span>
                  <p>Total received in the system.</p>
                </div>
                <div className="stats__icon"></div>
              </div>
              <div className="card stats">
                <div className="stats__content">
                  <h2 className="card__heading stats__heading">Paid</h2>
                  <span className="badge badge--danger stats__count">
                    {report.totalExpense}
                  </span>
                  <p>Total paid in the system.</p>
                </div>
                <div className="stats__icon"></div>
              </div>
              <div className="card stats">
                <div className="stats__content">
                  <h2 className="card__heading stats__heading">Net Amount</h2>
                  <span className="badge badge--accent stats__count">
                    {report.netAmount}
                  </span>
                  <p>Total net amount in the system.</p>
                </div>
                <div className="stats__icon"></div>
              </div>
              <div className="card stats">
                <div className="stats__content">
                  <h2 className="card__heading stats__heading">
                    <Link to={vehicleExpiryReportLink}>Vehicles Expiry</Link>
                  </h2>
                  <span className="badge badge--primary stats__count">
                    {report.totalVehicleExpiry}
                  </span>
                  <p>Total vehicles expiry in the system.</p>
                </div>
                <div className="stats__icon"></div>
              </div>
              <div className="card stats">
                <div className="stats__content">
                  <h2 className="card__heading stats__heading">
                    <Link to={visaExpiryReportLink}>Visas Expiry</Link>
                  </h2>
                  <span className="badge badge--primary stats__count">
                    {report.totalVisaExpiry}
                  </span>
                  <p>Total visas expiry in the system.</p>
                </div>
                <div className="stats__icon"></div>
              </div>
              <div className="card stats">
                <div className="stats__content">
                  <h2 className="card__heading stats__heading">
                    <Link to={passportExpiryReportLink}>Passports Expiry</Link>
                  </h2>
                  <span className="badge badge--primary stats__count">
                    {report.totalPassportExpiry}
                  </span>
                  <p>Total passport expiry in the system.</p>
                </div>
                <div className="stats__icon"></div>
              </div>
              <div className="card stats">
                <div className="stats__content">
                  <h2 className="card__heading stats__heading">
                    <Link to={checkReceivedReportLink}>Cheques Received</Link>
                  </h2>
                  <span className="badge badge--primary stats__count">
                    {report.totalReceivedChecks}
                  </span>
                  <p>Total cheques received in the system.</p>
                </div>
                <div className="stats__icon"></div>
              </div>
              <div className="card stats">
                <div className="stats__content">
                  <h2 className="card__heading stats__heading">
                    <Link to={checkPaidReportLink}>Cheques Issued</Link>
                  </h2>
                  <span className="badge badge--primary stats__count">
                    {report.totalPaidChecks}
                  </span>
                  <p>Total cheques issued in the system.</p>
                </div>
                <div className="stats__icon"></div>
              </div>
              <div className="card stats">
                <div className="stats__content">
                  <h2 className="card__heading stats__heading">
                    <Link to={invoiceReportLink}>Invoices Issued</Link>
                  </h2>
                  <span className="badge badge--primary stats__count">
                    {report.totalInvoices}
                  </span>
                  <p>Total invoices issued in the system.</p>
                </div>
                <div className="stats__icon"></div>
              </div>
              <div className="card stats">
                <div className="stats__content">
                  <h2 className="card__heading stats__heading">
                    <Link to={runningProjectsReportLink}>Running Projects</Link>
                  </h2>
                  <span className="badge badge--primary stats__count">
                    {report.runningProjects}
                  </span>
                  <p>Total running projects in the system.</p>
                </div>
                <div className="stats__icon"></div>
              </div>
              <div className="card stats">
                <div className="stats__content">
                  <h2 className="card__heading stats__heading">
                    <Link to={stopedProjectsReportLink}>Stoped Projects</Link>
                  </h2>
                  <span className="badge badge--primary stats__count">
                    {report.stopedProjects}
                  </span>
                  <p>Total stoped projects in the system.</p>
                </div>
                <div className="stats__icon"></div>
              </div>
              <div className="card stats">
                <div className="stats__content">
                  <h2 className="card__heading stats__heading">
                    <Link to={completedProjectsReportLink}>
                      Completed Projects
                    </Link>
                  </h2>
                  <span className="badge badge--primary stats__count">
                    {report.completedProjects}
                  </span>
                  <p>Total completed projects in the system.</p>
                </div>
                <div className="stats__icon"></div>
              </div>
              <div className="card stats">
                <div className="stats__content">
                  <h2 className="card__heading stats__heading">
                    <Link to={inReportLink}>Passport In</Link>
                  </h2>
                  <span className="badge badge--primary stats__count">
                    {report.totalPassportIn}
                  </span>
                  <p>Total passport in the system.</p>
                </div>
                <div className="stats__icon"></div>
              </div>

              <div className="card stats">
                <div className="stats__content">
                  <h2 className="card__heading stats__heading">
                    <Link to={outReportLink}>Passport Out</Link>
                  </h2>
                  <span className="badge badge--primary stats__count">
                    {report.totalPassportOut}
                  </span>
                  <p>Total passport out of the system.</p>
                </div>
                <div className="stats__icon"></div>
              </div>
            </React.Fragment>
          ) : (
            ""
          )}
        </div>

        {dashboard != "company" &&
        auth.getCurrentUser().role !== "salary-admin" &&
        report.newVisas.length > 0 ? (
          <div className="grid grid--1x2 dashboard-accounts-stats">
            <div className="card">
              <div className="stats__content">
                <h2 className="card__heading stats__heading">Rooms</h2>
                <div className="dashboard-accounts-stats__counter-container">
                  <span className="icon-container">
                    <span className="dashboard-accounts-stats__label">
                      {report.roomsActive}
                    </span>
                    <span className="dashboard-accounts-stats__heading">
                      Active
                    </span>
                  </span>
                  <span className="icon-container">
                    <span className="dashboard-accounts-stats__label">
                      {report.roomsInActive}
                    </span>
                    <span className="dashboard-accounts-stats__heading">
                      InActive
                    </span>
                  </span>
                </div>
                <div className="table dashboard-accounts-stats-table">
                  <header>
                    <div className="tr">
                      <div className="td">Sr#</div>
                      <div className="td">Room#</div>
                      <div className="td">Rent</div>
                      <div className="td">Incharge</div>
                    </div>
                  </header>
                  {report.newRooms.map((room) => (
                    <div className="tr non-collapsible">
                      <div className="td ">{room.sr}</div>
                      <div className="td">{room.room_number}</div>
                      <div className="td">{room.rent}</div>
                      <div className="td">
                        <Link
                          to={`/rooms-accounts/view/${room.id}?origin=dashboard`}
                        >
                          {room.name}
                        </Link>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
            <div className="card">
              <div className="stats__content">
                <h2 className="card__heading stats__heading">Vehicles</h2>
                <div className="dashboard-accounts-stats__counter-container">
                  <span className="icon-container">
                    <span className="dashboard-accounts-stats__label">
                      {report.vehiclesActive}
                    </span>
                    <span className="dashboard-accounts-stats__heading">
                      Active
                    </span>
                  </span>
                  <span className="icon-container">
                    <span className="dashboard-accounts-stats__label">
                      {report.vehiclesInActive}
                    </span>
                    <span className="dashboard-accounts-stats__heading">
                      InActive
                    </span>
                  </span>
                </div>
                <div className="table dashboard-accounts-stats-table">
                  <header>
                    <div className="tr">
                      <div className="td">Sr#</div>
                      <div className="td">Plat#</div>
                      <div className="td">Cost</div>
                      <div className="td">Mobile</div>
                    </div>
                  </header>
                  {report.newVehicles.map((vehicle) => (
                    <div className="tr non-collapsible">
                      <div className="td ">{vehicle.sr}</div>
                      <div className="td">
                        <Link
                          to={`/vehicles-accounts/view/${vehicle.id}?origin=dashboard`}
                        >
                          {vehicle.plat_number}
                        </Link>
                      </div>
                      <div className="td">{vehicle.cost}</div>
                      <div className="td">{vehicle.mobile}</div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
            <div className="card">
              <div className="stats__content">
                <h2 className="card__heading stats__heading">Visas</h2>
                <div className="dashboard-accounts-stats__counter-container">
                  <span className="icon-container">
                    <span className="dashboard-accounts-stats__label">
                      {report.visasActive}
                    </span>
                    <span className="dashboard-accounts-stats__heading">
                      Active
                    </span>
                  </span>
                  <span className="icon-container">
                    <span className="dashboard-accounts-stats__label">
                      {report.visasInActive}
                    </span>
                    <span className="dashboard-accounts-stats__heading">
                      InActive
                    </span>
                  </span>
                </div>
                <div className="table dashboard-accounts-stats-table">
                  <header>
                    <div className="tr">
                      <div className="td">Sr#</div>
                      <div className="td">Cost</div>
                      <div className="td">name#</div>
                    </div>
                  </header>
                  {report.newVisas.map((visa) => (
                    <div className="tr non-collapsible">
                      <div className="td ">{visa.sr}</div>
                      <div className="td">{visa.cost}</div>
                      <div className="td">
                        <Link
                          to={`/visas-accounts/view/${visa.id}?origin=dashboard`}
                        >
                          {visa.name}
                        </Link>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
            <div className="card">
              <div className="stats__content">
                <h2 className="card__heading stats__heading">Yards</h2>
                <div className="dashboard-accounts-stats__counter-container">
                  <span className="icon-container">
                    <span className="dashboard-accounts-stats__label">
                      {report.yardsActive}
                    </span>
                    <span className="dashboard-accounts-stats__heading">
                      Active
                    </span>
                  </span>
                  <span className="icon-container">
                    <span className="dashboard-accounts-stats__label">
                      {report.yardsInActive}
                    </span>
                    <span className="dashboard-accounts-stats__heading">
                      InActive
                    </span>
                  </span>
                </div>
                <div className="table dashboard-accounts-stats-table">
                  <header>
                    <div className="tr">
                      <div className="td">Sr#</div>
                      <div className="td">Rent#</div>
                      <div className="td">Name</div>
                    </div>
                  </header>
                  {report.newYards.map((yard) => (
                    <div className="tr non-collapsible">
                      <div className="td ">{yard.sr}</div>
                      <div className="td">{yard.rent}</div>
                      <div className="td">
                        <Link
                          to={`/yards-accounts/view/${yard.id}?origin=dashboard`}
                        >
                          {yard.name}
                        </Link>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        ) : (
          ""
        )}

        {/* <TableTitle
          title={report.currentDate}
          icon="tag"
          color="white"
          iconPath={dashboardIcon}
        />

        <div
          style={{
            display:
              dashboard == "company" &&
              auth.getCurrentUser().client == "Alpha Private School"
                ? "block"
                : "none",
          }}
        >
          <Grid>
            <Grid.Row>
              <Grid.Column width={4}>
                <Message>
                  <Statistic.Group widths="1">
                    <Statistic color="orange">
                      <Statistic.Value>
                        {report.company_web_contact_count}
                      </Statistic.Value>
                      <Statistic.Label>Contacts</Statistic.Label>
                    </Statistic>
                  </Statistic.Group>
                </Message>
              </Grid.Column>
              <Grid.Column width={4}>
                <Message>
                  <Statistic.Group widths="1">
                    <Statistic color="blue">
                      <Statistic.Value>
                        {report.company_web_tour_count}
                      </Statistic.Value>
                      <Statistic.Label>Tours</Statistic.Label>
                    </Statistic>
                  </Statistic.Group>
                </Message>
              </Grid.Column>
              <Grid.Column width={4}>
                <Message>
                  <Statistic.Group widths="1">
                    <Statistic color="yellow">
                      <Statistic.Value>
                        {report.company_web_news_count}
                      </Statistic.Value>
                      <Statistic.Label>News</Statistic.Label>
                    </Statistic>
                  </Statistic.Group>
                </Message>
              </Grid.Column>
              <Grid.Column width={4}>
                <Message>
                  <Statistic.Group widths="1">
                    <Statistic color="yellow">
                      <Statistic.Value>
                        {report.company_web_page_count}
                      </Statistic.Value>
                      <Statistic.Label>Pages</Statistic.Label>
                    </Statistic>
                  </Statistic.Group>
                </Message>
              </Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={4}>
                <Message>
                  <Statistic.Group widths="1">
                    <Statistic color="orange">
                      <Statistic.Value>
                        {report.company_web_teachers_count}
                      </Statistic.Value>
                      <Statistic.Label>Teachers</Statistic.Label>
                    </Statistic>
                  </Statistic.Group>
                </Message>
              </Grid.Column>
              <Grid.Column width={4}>
                <Message>
                  <Statistic.Group widths="1">
                    <Statistic color="blue">
                      <Statistic.Value>
                        {report.company_web_photos_count}
                      </Statistic.Value>
                      <Statistic.Label>Photos</Statistic.Label>
                    </Statistic>
                  </Statistic.Group>
                </Message>
              </Grid.Column>
              <Grid.Column width={4}></Grid.Column>
              <Grid.Column width={4}></Grid.Column>
            </Grid.Row>
          </Grid>
        </div>

        <div
          style={{
            display:
              dashboard == "company" &&
              auth.getCurrentUser().client != "Gondalism" &&
              auth.getCurrentUser().client != "Alpha Private School"
                ? "block"
                : "none",
          }}
        >
          <Grid>
            <Grid.Row>
              <Grid.Column width={4}>
                <Message>
                  <Message.Header>Rooms</Message.Header>

                  <Statistic.Group widths="2">
                    <Statistic color="orange">
                      <Statistic.Value>{report.room_count}</Statistic.Value>
                      <Statistic.Label>Total Accounts</Statistic.Label>
                    </Statistic>

                    <Statistic color="orange">
                      <Statistic.Value>
                        {report.room_ledger_type_count}
                      </Statistic.Value>
                      <Statistic.Label>Ledger Types</Statistic.Label>
                    </Statistic>
                  </Statistic.Group>
                </Message>
              </Grid.Column>
              <Grid.Column width={4}>
                <Message>
                  <Message.Header>Vehicles</Message.Header>

                  <Statistic.Group widths="2">
                    <Statistic color="blue">
                      <Statistic.Value>{report.vehicle_count}</Statistic.Value>
                      <Statistic.Label>Total Accounts</Statistic.Label>
                    </Statistic>

                    <Statistic color="blue">
                      <Statistic.Value>
                        {report.vehicle_ledger_type_count}
                      </Statistic.Value>
                      <Statistic.Label>Ledger Types</Statistic.Label>
                    </Statistic>
                  </Statistic.Group>
                </Message>
              </Grid.Column>
              <Grid.Column width={4}>
                <Message>
                  <Message.Header>Visas</Message.Header>

                  <Statistic.Group widths="2">
                    <Statistic color="yellow">
                      <Statistic.Value>{report.visa_count}</Statistic.Value>
                      <Statistic.Label>Total Accounts</Statistic.Label>
                    </Statistic>

                    <Statistic color="yellow">
                      <Statistic.Value>
                        {report.visa_ledger_type_count}
                      </Statistic.Value>
                      <Statistic.Label>Ledger Types</Statistic.Label>
                    </Statistic>
                  </Statistic.Group>
                </Message>
              </Grid.Column>
              <Grid.Column width={4}>
                <Message>
                  <Message.Header>Yards</Message.Header>

                  <Statistic.Group widths="2">
                    <Statistic color="yellow">
                      <Statistic.Value>{report.yard_count}</Statistic.Value>
                      <Statistic.Label>Total Accounts</Statistic.Label>
                    </Statistic>

                    <Statistic color="yellow">
                      <Statistic.Value>
                        {report.yard_ledger_type_count}
                      </Statistic.Value>
                      <Statistic.Label>Ledger Types</Statistic.Label>
                    </Statistic>
                  </Statistic.Group>
                </Message>
              </Grid.Column>
            </Grid.Row>

            <Grid.Row>
              <Grid.Column width={4}>
                <Message>
                  <Message.Header>Users</Message.Header>

                  <Statistic.Group widths="1">
                    <Statistic color="brown">
                      <Statistic.Value>
                        {report.company_account_count}
                      </Statistic.Value>
                      <Statistic.Label>Total</Statistic.Label>
                    </Statistic>
                  </Statistic.Group>
                </Message>
              </Grid.Column>

              <Grid.Column width={4}>
                <Message>
                  <Message.Header>Banks</Message.Header>

                  <Statistic.Group widths="1">
                    <Statistic color="white">
                      <Statistic.Value>
                        {report.company_bank_detail_count}
                      </Statistic.Value>
                      <Statistic.Label>Total</Statistic.Label>
                    </Statistic>
                  </Statistic.Group>
                </Message>
              </Grid.Column>

              <Grid.Column width={4}>
                <Message>
                  <Message.Header>Documents</Message.Header>

                  <Statistic.Group widths="1">
                    <Statistic color="red">
                      <Statistic.Value>
                        {report.company_document_count}
                      </Statistic.Value>
                      <Statistic.Label>Total</Statistic.Label>
                    </Statistic>
                  </Statistic.Group>
                </Message>
              </Grid.Column>
            </Grid.Row>
          </Grid>
        </div>
        <div
          style={{
            display:
              dashboard != "company" &&
              auth.getCurrentUser().role != "salary-admin"
                ? "block"
                : "none",
          }}
        >
          <center>
            <div className="ui error  " style={{ width: "70%" }}>
              <Table>
                <Table.Body>
                  <Table.Row width="16">
                    <Table.Cell style={{ textAlign: "right" }}>
                      <b>Start Date</b>
                    </Table.Cell>
                    <Table.Cell>
                      <DatePicker
                        selected={this.state.startDate}
                        onChange={this.handleChangeStartDate}
                      />
                      <br />
                      <small>(month/day/year)</small>
                    </Table.Cell>
                    <Table.Cell style={{ textAlign: "right" }}>
                      <b>End Date</b>
                    </Table.Cell>
                    <Table.Cell>
                      <DatePicker
                        selected={this.state.endDate}
                        onChange={this.handleChangeEndDate}
                      />
                      <br />
                      <small>(month/day/year)</small>
                    </Table.Cell>
                    <Table.Cell colSpan="5">
                      <center>
                        <Button color="green" onClick={this.doSubmit}>
                          Generate Dashboard
                        </Button>
                        <Button color="grey" onClick={this.doReset}>
                          Reset
                        </Button>
                      </center>
                    </Table.Cell>
                  </Table.Row>
                </Table.Body>
              </Table>
              <Message
                negative
                style={{
                  display: this.state.showError == true ? "block" : "none",
                }}
              >
                <Message.Header>Error</Message.Header>
                <p>Data not found for the dates specified.</p>
              </Message>
            </div>
          </center>

          <Grid>
            {report.companyExpiryCounter != undefined ? (
              <Grid.Row>
                <Grid.Column width={6}></Grid.Column>
                <Grid.Column width={4} style={{ marginTop: "12px" }}>
                  <Message>
                    <Statistic.Group widths="1">
                      <Statistic color="orange">
                        <Statistic.Value>
                          <a href={documentsExpiryReportLink}>
                            {report.companyExpiryCounter}
                          </a>
                        </Statistic.Value>
                        <Statistic.Label>Dcouments Expiry</Statistic.Label>
                      </Statistic>
                    </Statistic.Group>
                  </Message>
                </Grid.Column>
                <Grid.Column width={6}></Grid.Column>
              </Grid.Row>
            ) : (
              ""
            )}
            <Grid.Row>
              <Grid.Column width={4}>
                <Message>
                  <Statistic.Group widths="1">
                    <Statistic color="orange">
                      <Statistic.Value>
                        <a href="/report/generate-receiveable-report">
                          {report.totalReceivable}
                        </a>
                      </Statistic.Value>
                      <Statistic.Label>Total Receiveable</Statistic.Label>
                    </Statistic>
                  </Statistic.Group>
                </Message>
              </Grid.Column>
              <Grid.Column width={4}>
                <Message>
                  <Statistic.Group widths="1">
                    <Statistic color="blue">
                      <Statistic.Value>
                        <a href="/report/generate-payable-report">
                          {report.totalPayable}
                        </a>
                      </Statistic.Value>
                      <Statistic.Label>Total Payable</Statistic.Label>
                    </Statistic>
                  </Statistic.Group>
                </Message>
              </Grid.Column>
              <Grid.Column width={4}>
                <Message>
                  <Statistic.Group widths="1">
                    <Statistic color="yellow">
                      <Statistic.Value>{report.totalIncome}</Statistic.Value>
                      <Statistic.Label>Total Received</Statistic.Label>
                    </Statistic>
                  </Statistic.Group>
                </Message>
              </Grid.Column>
              <Grid.Column width={4}>
                <Message>
                  <Statistic.Group widths="1">
                    <Statistic color="red">
                      <Statistic.Value>{report.totalExpense}</Statistic.Value>
                      <Statistic.Label>Total Paid</Statistic.Label>
                    </Statistic>
                  </Statistic.Group>
                </Message>
              </Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={4}>
                <Message>
                  <Statistic.Group widths="1">
                    <Statistic color="orange">
                      <Statistic.Value>{report.netAmount}</Statistic.Value>
                      <Statistic.Label>Net Amount</Statistic.Label>
                    </Statistic>
                  </Statistic.Group>
                </Message>
              </Grid.Column>

              <Grid.Column width={4}>
                <Message>
                  <Statistic.Group widths="1">
                    <Statistic color="blue">
                      <Statistic.Value>
                        <a href={vehicleExpiryReportLink}>
                          {report.totalVehicleExpiry}
                        </a> 
                      </Statistic.Value>
                      <Statistic.Label>Vehicle Total Expiry</Statistic.Label>
                    </Statistic>
                  </Statistic.Group>
                </Message>
              </Grid.Column>
              <Grid.Column width={4}>
                <Message>
                  <Statistic.Group widths="1">
                    <Statistic color="yellow">
                      <Statistic.Value>
                        <a href={visaExpiryReportLink}>
                          {report.totalVisaExpiry}
                        </a>
                      </Statistic.Value>
                      <Statistic.Label>Visa Total Expiry</Statistic.Label>
                    </Statistic>
                  </Statistic.Group>
                </Message>
              </Grid.Column>
              <Grid.Column width={4}>
                <Message>
                  <Statistic.Group widths="1">
                    <Statistic color="red">
                      <Statistic.Value>
                        <a href={passportExpiryReportLink}>
                          {report.totalPassportExpiry}
                        </a>
                      </Statistic.Value>
                      <Statistic.Label>Passport Total Expiry</Statistic.Label>
                    </Statistic>
                  </Statistic.Group>
                </Message>
              </Grid.Column>

              <Grid.Column width={4} style={{ marginTop: "26px" }}>
                <Message>
                  <Statistic.Group widths="1">
                    <Statistic color="orange">
                      <Statistic.Value>
                        <a href={checkReceivedReportLink}>
                          {report.totalReceivedChecks}
                        </a>
                      </Statistic.Value>
                      <Statistic.Label>Cheques Received</Statistic.Label>
                    </Statistic>
                  </Statistic.Group>
                </Message>
              </Grid.Column>
              <Grid.Column width={4} style={{ marginTop: "26px" }}>
                <Message>
                  <Statistic.Group widths="1">
                    <Statistic color="blue">
                      <Statistic.Value>
                        <a href={checkPaidReportLink}>
                          {report.totalPaidChecks}
                        </a>
                      </Statistic.Value>
                      <Statistic.Label>Cheques Issued</Statistic.Label>
                    </Statistic>
                  </Statistic.Group>
                </Message>
              </Grid.Column>
              <Grid.Column
                width={4}
                style={{ marginBottom: "30px", marginTop: "26px" }}
              >
                <Message>
                  <Statistic.Group widths="1">
                    <Statistic color="yellow">
                      <Statistic.Value>
                        <a href={invoiceReportLink}>{report.totalInvoices}</a>
                      </Statistic.Value>
                      <Statistic.Label>Invoices Issued</Statistic.Label>
                    </Statistic>
                  </Statistic.Group>
                </Message>
              </Grid.Column>
              <Grid.Column
                width={4}
                style={{ marginBottom: "30px", marginTop: "26px" }}
              >
                <Message>
                  <Statistic.Group widths="1">
                    <Statistic color="red">
                      <Statistic.Value>
                        <a href={runningProjectsReportLink}>
                          {report.runningProjects}
                        </a>
                      </Statistic.Value>
                      <Statistic.Label>Running Projects</Statistic.Label>
                    </Statistic>
                  </Statistic.Group>
                </Message>
              </Grid.Column>

              <Grid.Column width={4} style={{ marginBottom: "30px" }}>
                <Message>
                  <Statistic.Group widths="1">
                    <Statistic color="orange">
                      <Statistic.Value>
                        <a href={stopedProjectsReportLink}>
                          {report.stopedProjects}
                        </a>
                      </Statistic.Value>
                      <Statistic.Label>Stoped Projects</Statistic.Label>
                    </Statistic>
                  </Statistic.Group>
                </Message>
              </Grid.Column>
              <Grid.Column width={4} style={{ marginBottom: "30px" }}>
                <Message>
                  <Statistic.Group widths="1">
                    <Statistic color="blue">
                      <Statistic.Value>
                        <a href={completedProjectsReportLink}>
                          {report.completedProjects}
                        </a>
                      </Statistic.Value>
                      <Statistic.Label>Completed Projects</Statistic.Label>
                    </Statistic>
                  </Statistic.Group>
                </Message>
              </Grid.Column>
              <Grid.Column width={4} style={{ marginBottom: "30px" }}>
                <Message>
                  <Statistic.Group widths="1">
                    <Statistic color="blue">
                      <Statistic.Value>
                        <a href={inReportLink}>{report.totalPassportIn}</a>
                      </Statistic.Value>
                      <Statistic.Label>Total Passport In</Statistic.Label>
                    </Statistic>
                  </Statistic.Group>
                </Message>
              </Grid.Column>
              <Grid.Column width={4} style={{ marginBottom: "30px" }}>
                <Message>
                  <Statistic.Group widths="1">
                    <Statistic color="blue">
                      <Statistic.Value>
                        <a href={outReportLink}>{report.totalPassportOut}</a>
                      </Statistic.Value>
                      <Statistic.Label>Total Passport Out</Statistic.Label>
                    </Statistic>
                  </Statistic.Group>
                </Message>
              </Grid.Column>
            </Grid.Row>

            {/* {report.companyExpiryCounter != undefined ? (
             <Grid.Row>
                  <Grid.Column width={4} style={{ marginBottom:'30px' }}>
                    <Message>
                      <Statistic.Group widths="1">
                        <Statistic color="orange">
                          <Statistic.Value><a href={documentsExpiryReportLink}>{report.companyExpiryCounter}</a></Statistic.Value>
                          <Statistic.Label>Dcouments Expiry</Statistic.Label>
                        </Statistic>
                      </Statistic.Group>
                    </Message>
                  </Grid.Column>
            </Grid.Row> ) : ""} */}
        {/* </Grid> 
        </div> */}
      </BlockUi>
    );
  }
}

export default Dashboard;
